import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavigateButton } from '../../../components/Button/NavigateButton';

type Props = {
  text?: string;
};

export const NavigateCreatePageButton: FC<Props> = ({ text }) => {
  const { t } = useTranslation();
  return (
    <NavigateButton
      fullPath
      path="/rs/project/new"
      text={text ?? t('create')}
    />
  );
};
